export const updateSection = section => ({
  type: "UPDATE_SECTION",
  section
});



/** WEBPACK FOOTER **
 ** ./src/core/section/actions.js
 **/